module.exports = __webpack_public_path__ + "static/media/Piercing-ear-helixforward.e3ec325f.png";